






















































































































































































































































































import { Component, Vue, Watch } from 'vue-property-decorator'
import { TableColumnItemType, OperationItemType, TabItem, OptionItemType } from '../../types/type'
import { CommonModule, CanteenModule } from '../../store'
import { Pagination } from '../../mixins/pagination'
import { getArrChildForTree, findItemForTree, getNameTextInOptions, findOneForOrginationTree } from '../../utils/toolsForCommon'
import DateUtil from '../../utils/toolsForDate'
import html2canvas from 'html2canvas'
@Component({
  name: 'FinanceSupervise',
  mixins: [Pagination],
  components: {
    'my-table': () => import('../../components/common/myTable/index.vue'),
    'detail-account-table': () => import('../../components/detailAccountTable/index.vue'),
    'general-ledger-table': () => import('../../components/generalLedgerTable/index.vue'),
    'income-and-expenses-detail-table': () => import('../../components/incomeAndExpensesDetailTable/index.vue'),
    'property-liabilities-table': () => import('../../components/propertyLiabilitiesTable/index.vue'),
    'remaining-sum-table': () => import('../../components/remainingSumTable/index.vue')
  }
})
export default class FinanceSupervise extends Vue {
  // tab相关：
  public paneName: string = 'accountingProgress'
  public tablist: Array<TabItem> = [
    {
      title: '核算进度',
      key: 'accountingProgress'
    },
    {
      title: '流水记录',
      key: 'incomeAndExpenses'
    },
    {
      title: '明细账',
      key: 'detailAccountTableModule'
    },
    {
      title: '总账',
      key: 'generalLedgerTableModule'
    },
    {
      title: '收支明细表',
      key: 'incomeAndExpensesDetailTableModule'
    },
    {
      title: '资产负债表',
      key: 'propertyLiabilitiesTableModule'
    },
    {
      title: '余额表',
      key: 'remainingSumTableModule'
    }
  ]
  // tree相关：
  public filterText: string = ''
  public checkedKeysForTree: Array<string | number> = []
  // 核算进度相关：
  // 列表列有哪些：
  public moduleTitleListForAccountingProgress: Array<TableColumnItemType> = [
    {
      title: '乡镇',
      key: 'town',
      type: 'text',
      flex: 1,
      width: '200px'
    },
    {
      title: '学校',
      key: 'school',
      type: 'text',
      flex: 1,
      width: '200px'
    },
    {
      title: '账务核算统计（月份）',
      key: 'hasJournal',
      flex: 2,
      showStateForTableHeader: 'two-double',
      child: [
        {
          title: '1',
          key: 'January',
          type: 'text',
          width: '150px'
        },
        {
          title: '2',
          key: 'February',
          type: 'text'
        },
        {
          title: '3',
          key: 'March',
          type: 'text'
        },
        {
          title: '4',
          key: 'April',
          type: 'text'
        },
        {
          title: '5',
          key: 'May',
          type: 'text'
        },
        {
          title: '6',
          key: 'June',
          type: 'text'
        },
        {
          title: '7',
          key: 'July',
          type: 'text'
        },
        {
          title: '8',
          key: 'August',
          type: 'text'
        },
        {
          title: '9',
          key: 'September',
          type: 'text'
        },
        {
          title: '10',
          key: 'October',
          type: 'text'
        },
        {
          title: '11',
          key: 'November',
          type: 'text'
        },
        {
          title: '12',
          key: 'December',
          type: 'text'
        }
      ]
    }
  ]
  // 枚举选项：
  public optionsForMonth: Array<OptionItemType> = [
    {
      name: '1',
      value: 'January'
    },
    {
      name: '2',
      value: 'February'
    },
    {
      name: '3',
      value: 'March'
    },
    {
      name: '4',
      value: 'April'
    },
    {
      name: '5',
      value: 'May'
    },
    {
      name: '6',
      value: 'June'
    },
    {
      name: '7',
      value: 'July'
    },
    {
      name: '8',
      value: 'August'
    },
    {
      name: '9',
      value: 'September'
    },
    {
      name: '10',
      value: 'October'
    },
    {
      name: '11',
      value: 'November'
    },
    {
      name: '12',
      value: 'December'
    }
  ]
  public loadingForAccountingProgress = false
  // 流水记录相关：
  // 列表列有哪些：
  public moduleTitleListForIncomeAndExpenses: Array<TableColumnItemType> = [
    {
      title: '时间',
      key: 'time',
      type: 'text',
      flex: 1,
      width: '180px'
    },
    {
      title: '学校',
      key: 'orgName',
      type: 'text',
      flex: 1,
      width: '200px'
    },
    {
      title: '摘要',
      key: 'summary',
      type: 'text',
      flex: 1,
      width: '200px'
    },
    {
      title: '科目',
      key: 'subject',
      type: 'text',
      flex: 1,
      width: '200px'
    },
    {
      title: '收支形式',
      key: 'incOrExp',
      type: 'text',
      flex: 1,
      width: '200px'
    },
    {
      title: '资金形式',
      key: 'capitalType',
      type: 'text',
      flex: 1,
      width: '200px'
    },
    {
      title: '金额（元）',
      key: 'money',
      type: 'text',
      flex: 1,
      width: '200px'
    },
    {
      title: '数量',
      key: 'amount',
      type: 'text',
      flex: 1,
      width: '200px'
    },
    {
      title: '单位',
      key: 'unit',
      type: 'text',
      flex: 1,
      width: '200px'
    },
    {
      title: '备注',
      key: 'comment',
      type: 'text',
      flex: 1,
      width: '200px'
    },
    {
      title: '操作',
      key: 'operationInTable',
      flex: 1,
      width: '160px'
    }
  ]
  public columnOperationListForIncomeAndExpenses: Array<OperationItemType> = [
    {
      title: '详情',
      key: 'detail',
      type: 'primary',
      size: 'mini'
    }
  ]
  // 枚举选项：
  public optionsForIncOrExp: Array<OptionItemType> = [
    {
      name: '收入',
      value: true
    },
    {
      name: '支出',
      value: false
    }
  ]
  public pageSizeForIncomeAndExpenses: number = 20
  public currentPageForIncomeAndExpense: number = 1
  public totalForIncomeAndExpense: number = 0
  public tableDataListForIncomeAndExpense: any[] = []
  public nowPageForIncomeAndExpense: number = 0
  public loadingForIncomeAndExpense = false
  // 报表详情相关：
  public tableDetailForDetailAccountTableContainer: any = {}
  public tableDetailForGeneralLedgerTableContainer: any = {}
  public tableDetailForIncomeAndExpensesDetailTableContainer: any = {}
  public tableDetailForPropertyLiabilitiesTableContainer: any = {}
  public tableDetailForRemainingSumTableContainer: any = {}
  public loadingForDetailAccountTableContainer: boolean = false
  public loadingForGeneralLedgerTableContainer: boolean = false
  public loadingForIncomeAndExpensesDetailTableContainer: boolean = false
  public loadingForPropertyLiabilitiesTableContainer: boolean = false
  public loadingForRemainingSumTableContainer: boolean = false
  // 右侧头部相关：
  public yearForDate: string = ''
  public monthForDate: string = ''
  // 针对流水记录，搜索相关：
  public daterangeForDateForSearch: Array<string> = []
  public summaryForSearch: string = ''
  public incOrExpForSearch: string = ''
  public timerIdForSummaryForSearch: number = 0
  // 针对科目的选择：
  public subjectChecked: string | Array<string> = ''
  public subjectTreeData: Array<any> = []
  // 针对学校基本信息：
  public schoolBaseInfo: any = {}
  public schoolBaseInfoLoading = false
  public reportFormSubjectAnalyzeDetail = {}

  get treeDataForSubOrganatizion () {
    return CommonModule.treeDataForSubOrganatizion
  }

  get treeDataForOrganatizion () {
    return CommonModule.treeDataForOrganatizion
  }

  get treeDataForDisposeNameSubject () {
    return CanteenModule.treeDataForDisposeNameSubject
  }

  get batch (): string {
    let res = ''
    if (this.monthForDate) {
      res = this.monthForDate.split('-')[0] + this.monthForDate.split('-')[1]
    }
    return res
  }

  get thisSchoolName (): string {
    if (!this.checkedKeysForTree.length) return '- -'
    const res = findOneForOrginationTree(this.treeDataForSubOrganatizion, this.checkedKeysForTree[0])
    return res ? res.name : '- -'
  }

  get thisSchoolNameForSome (): string {
    if (!this.checkedKeysForTree.length) return '- -'
    let resStr = ''
    const res = this.checkedKeysForTree.map(item => {
      return findOneForOrginationTree(this.treeDataForSubOrganatizion, item)
    })
    if (res.length > 2) {
      resStr = res.slice(0, 2).map(item => item.name).join('、') + ' ' + '等' + res.length + '所学校'
    } else {
      resStr = res.map(item => item.name).join('、')
    }
    return resStr
  }

  get tableNameText (): string {
    let tableNameText = ''
    switch (this.paneName) {
      case 'detailAccountTableModule':
        tableNameText = '《公安县中小学食堂明细账》'
        break
      case 'generalLedgerTableModule':
        tableNameText = '《公安县中小学食堂总账》'
        break
      case 'incomeAndExpensesDetailTableModule':
        tableNameText = '《公安县中小学食堂收支明细表》'
        break
      case 'propertyLiabilitiesTableModule':
        tableNameText = '《公安县中小学食堂资产负债表》'
        break
      case 'remainingSumTableModule':
        tableNameText = '《公安县中小学食堂余额表》'
        break
    }
    return tableNameText
  }

  get tableId (): string {
    let tableId = ''
    switch (this.paneName) {
      case 'detailAccountTableModule':
        tableId = 'detailAccountTable'
        break
      case 'generalLedgerTableModule':
        tableId = 'generalLedgerTable'
        break
      case 'incomeAndExpensesDetailTableModule':
        tableId = 'incomeAndExpensesDetailTable'
        break
      case 'propertyLiabilitiesTableModule':
        tableId = 'propertyLiabilitiesTable'
        break
      case 'remainingSumTableModule':
        tableId = 'remainingSumTable'
        break
    }
    return tableId
  }

  @Watch('filterText') filterTextChange (val: any) {
    ;(this as any).$refs[`${this.paneName}OfTree`][0].filter(val)
  }

  async mounted () {
    this.getCurrentYear()
    this.getLastMonth()
    const { paneName } = this.$route.query
    paneName && (this.paneName = paneName as string)
    await Promise.all([
      CommonModule.getTreeDataForSubOrganization(),
      CommonModule.getTreeDataForOrganization(),
      CanteenModule.getTreeDataForDisposeNameSubject()
    ])
    this.initForTreeCheck()
    this.$nextTick(() => {
      this.treeInit()
      this.getDateForWho()
    })
    this.$on('hook:beforeDestroy', () => {
      this.timerIdForSummaryForSearch && clearTimeout(this.timerIdForSummaryForSearch)
    })
  }

  getCurrentYear () {
    this.yearForDate = String(new Date().getFullYear())
  }

  getLastMonth () {
    this.monthForDate = DateUtil.getLastMonth()
  }

  initForTreeCheck () {
    this.subjectTreeData = this.treeDataForDisposeNameSubject
  }

  // 选择年份：
  changeForYearForDate (value): void {
    this.beforeLeave(this.paneName)
  }

  // 选择月份：
  changeForMonthForDate (value): void {
    this.beforeLeave(this.paneName)
  }

  // 选择日期：
  changeForDaterangeForDateForSearch (value): void {
    this.beforeLeave(this.paneName)
  }

  // 输入摘要：
  inputForSummaryForSearch () {
    this.timerIdForSummaryForSearch && clearTimeout(this.timerIdForSummaryForSearch)
    this.timerIdForSummaryForSearch = setTimeout(() => {
      this.beforeLeave(this.paneName)
    }, 500)
  }

  // 选择资金形式：
  changeForIncOrExpForSearch () {
    this.beforeLeave(this.paneName)
  }

  resetBtn () {
    this.daterangeForDateForSearch = []
    this.summaryForSearch = this.incOrExpForSearch = ''
    this.beforeLeave(this.paneName)
  }

  treeInit () {
    const list = getArrChildForTree(this.treeDataForSubOrganatizion, 'children').map(item => item.id)
    if (list.length) {
      this.checkedKeysForTree = [list[0]]
      ;(this as any).$refs[`${this.paneName}OfTree`][0].setCheckedKeys(this.checkedKeysForTree)
    }
  }

  beforeLeave (activeName: string): void {
    ;(this.$refs[`${activeName}OfTree`][0] as any).filter(this.filterText)
    // 默认帮忙选择的时候，需要判断，如果是三个报表则需要单选：
    if (activeName === 'incomeAndExpensesDetailTableModule' || activeName === 'propertyLiabilitiesTableModule' || activeName === 'remainingSumTableModule') {
      if (this.checkedKeysForTree.length) {
        ;(this as any).$refs[`${activeName}OfTree`][0].setCheckedKeys([this.checkedKeysForTree[0]])
      } else {
        ;(this as any).$refs[`${activeName}OfTree`][0].setCheckedKeys([])
      }
    } else {
      ;(this as any).$refs[`${activeName}OfTree`][0].setCheckedKeys(this.checkedKeysForTree)
    }
    this.$router.replace({ name: 'FinanceSupervise', query: { paneName: activeName } })
    this.paneName = activeName
    if (this.checkedKeysForTree.length) {
      this.getDateForWho()
    } else {
      this.initDateForWho()
    }
  }

  getDateForWho () {
    switch (this.paneName) {
      case 'accountingProgress':
        this.getTableDataList()
        break
      case 'incomeAndExpenses':
        this.getTableDataListForIncomeAndExpense()
        break
      case 'detailAccountTableModule':
        this.getReportFormLedgerDetail()
        break
      case 'generalLedgerTableModule':
        this.getReportFormLedger()
        break
      case 'incomeAndExpensesDetailTableModule':
        this.getReportFormIncomeAndOutputDetailQuery()
        this.getSchoolBaseInfo()
        break
      case 'propertyLiabilitiesTableModule':
        this.getReportFormAssetsAndLiabilitiesQuery()
        this.getSchoolBaseInfo()
        break
      case 'remainingSumTableModule':
        this.getReportFormSubjectBalanceQuery()
        this.getSchoolBaseInfo()
        break
    }
  }

  initDateForWho () {
    switch (this.paneName) {
      case 'accountingProgress':
        (this as any).tableDataList = []
        break
      case 'incomeAndExpenses':
        this.tableDataListForIncomeAndExpense = []
        this.totalForIncomeAndExpense = 0
        break
      case 'detailAccountTableModule':
        this.tableDetailForDetailAccountTableContainer = {}
        break
      case 'generalLedgerTableModule':
        this.tableDetailForGeneralLedgerTableContainer = {}
        break
      case 'incomeAndExpensesDetailTableModule':
        this.tableDetailForIncomeAndExpensesDetailTableContainer = {}
        break
      case 'propertyLiabilitiesTableModule':
        this.tableDetailForPropertyLiabilitiesTableContainer = {}
        break
      case 'remainingSumTableModule':
        this.tableDetailForRemainingSumTableContainer = {}
        break
    }
  }

  filterNode (value: any, data: any) {
    if (!value) return true
    return data.name.indexOf(value) !== -1
  }

  handleCheckChange (current, { checkedKeys }): void {
    // 原本是这样，但是缺点是：会把所有选中的节点都带上：
    // this.checkedKeysForTree = checkedKeys
    // 但实际只需要末节点：
    this.checkedKeysForTree = (this as any).$refs[`${this.paneName}OfTree`][0].getCheckedKeys(true)
    if (this.checkedKeysForTree.length) {
      this.getDateForWho()
    } else {
      this.initDateForWho()
    }
  }

  // tree单选：
  handleCheckChangeReal (data, checkbox) {
    // 核算进度和流水记录不需要单选，所以排除：
    if (this.paneName === 'accountingProgress' || this.paneName === 'incomeAndExpenses') return
    // 只有三个报表需要单选：
    const treeDom = (this as any).$refs[`${this.paneName}OfTree`][0]
    if (checkbox) {
      treeDom.setCheckedKeys([data.id])
    }
  }

  // 操作按钮：
  operationForButton ({ key }, row) {
    const { id, orgId } = row
    switch (key) {
      case 'detail':
        this.$router.push({
          name: 'IncomeAndExpensesDetail',
          query: {
            id,
            orgId
          }
        })
    }
  }

  // 核算进度：
  async getTableDataList () {
    try {
      const _that: any = this
      this.loadingForAccountingProgress = true
      const listForGetCheckedKeys = (this as any).$refs[`${this.paneName}OfTree`][0].getCheckedKeys(true)
      const params = {
        school: listForGetCheckedKeys.join(','),
        year: this.yearForDate
      }
      const { data: result } = await (this as any).$http.journalAggQuery(params)
      this.loadingForAccountingProgress = false
      if (result.code !== 200) return this.$message.error(result.msg)
      _that.tableDataList = (result.data || []).map(item => {
        item.town = findItemForTree(this.treeDataForOrganatizion, 'children', 'id', item.town)['name']
        item.school = findItemForTree(this.treeDataForOrganatizion, 'children', 'id', item.school)['name']
        const objForMonth = item.hasJournal.reduce((result, currentItem, currentIndex) => {
          const month = this.optionsForMonth[currentIndex].value as string
          result[month] = currentItem === true ? '有' : (currentItem === false ? '无' : (currentItem === null ? '未统计' : ''))
          return result
        }, {})
        return {
          ...item,
          ...objForMonth
        }
      })
    } catch (err) {
      console.log(err)
    }
  }

  // 流水记录：
  async getTableDataListForIncomeAndExpense () {
    try {
      const _that: any = this
      this.loadingForIncomeAndExpense = true
      const pageParams = {
        pageNo: _that.currentPageForIncomeAndExpense,
        pageSize: _that.pageSizeForIncomeAndExpenses
      }
      const listForGetCheckedKeys = (this as any).$refs[`${this.paneName}OfTree`][0].getCheckedKeys(true)
      const searchParams = {
        orgId: listForGetCheckedKeys[0],
        orgIds: listForGetCheckedKeys.join(','),
        summary: this.summaryForSearch,
        incOrExp: this.incOrExpForSearch
      }
      if (this.daterangeForDateForSearch && this.daterangeForDateForSearch.length) {
        const [startTime, endTime] = this.daterangeForDateForSearch
        Object.assign(searchParams, {
          startTime: startTime + ' 00:00:00',
          endTime: endTime + ' 23:59:59'
        })
      }
      const params = {
        ...pageParams,
        ...searchParams
      }
      const { data: result } = await (this as any).$http.journalQuery(params)
      this.loadingForIncomeAndExpense = false
      if (result.code !== 200) return this.$message.error(result.msg)
      _that.tableDataListForIncomeAndExpense = ((result.data && result.data.records) || []).map(item => {
        item.subject = findItemForTree(this.treeDataForDisposeNameSubject, 'children', 'code', item.subject)['name']
        item.incOrExp = getNameTextInOptions(this.optionsForIncOrExp, item.incOrExp)
        item.capitalType = findItemForTree(this.treeDataForDisposeNameSubject, 'children', 'code', item.capitalType)['name']
        item.time = item.time.split(' ')[0]
        return item
      })
      _that.totalForIncomeAndExpense = result.data.total
    } catch (err) {
      console.log(err)
    }
  }

  handleSizeChangeForIncomeAndExpense (pageSize: number): void {
    let _that: any = this
    _that.pageSizeForIncomeAndExpenses = pageSize
    _that.nowPageForIncomeAndExpense = (_that.currentPageForIncomeAndExpense - 1) * _that.pageSizeForIncomeAndExpenses
    _that.getTableDataListForIncomeAndExpense()
  }

  handleCurrentChangeForIncomeAndExpense (currentPage: number): void {
    let _that: any = this
    _that.currentPageForIncomeAndExpense = currentPage
    _that.nowPageForIncomeAndExpense = (_that.currentPageForIncomeAndExpense - 1) * _that.pageSizeForIncomeAndExpenses
    _that.getTableDataListForIncomeAndExpense()
  }

  // 明细账：
  async getReportFormLedgerDetail () {
    try {
      const listForGetCheckedKeys = (this as any).$refs[`${this.paneName}OfTree`][0].getCheckedKeys(true)
      if (!listForGetCheckedKeys.length) return this.$message.warning('抱歉，您暂未选择学校哦！')
      const params = {
        school: listForGetCheckedKeys[0],
        year: this.yearForDate
      }
      if (this.subjectChecked) {
        if (this.subjectChecked.length) {
          Object.assign(params, {
            subject: this.subjectChecked[this.subjectChecked.length - 1]
          })
        }
      }
      this.loadingForDetailAccountTableContainer = true
      const { data: result } = await (this as any).$http.reportFormLedgerDetail(params)
      this.loadingForDetailAccountTableContainer = false
      if (result.code !== 200) {
        this.tableDetailForDetailAccountTableContainer = {}
        return this.$message.error(result.msg)
      }
      // 需要对数据进行处理：
      const list = (result.data || []).reduce((resultRes: any, current: any): Array<any> => {
        if (current.monthlyDetailLedgers) {
          current.monthlyDetailLedgers.forEach(item => {
            if (item.itemDetails) {
              item.itemDetails.forEach(v => {
                resultRes.push(v)
              })
            }
          })
        }
        return resultRes
      }, [])
      this.tableDetailForDetailAccountTableContainer = {
        list,
        year: this.yearForDate
      }
      if (this.subjectChecked) {
        if (this.subjectChecked.length) {
          const subject = findItemForTree(this.treeDataForDisposeNameSubject, 'children', 'code', this.subjectChecked[this.subjectChecked.length - 1])
          Object.assign(this.tableDetailForDetailAccountTableContainer, {
            subject: subject && subject['name'] ? subject['name'] : '- -'
          })
        }
      }
    } catch (err) {
      console.log(err)
    }
  }

  // 总账：
  async getReportFormLedger () {
    try {
      const listForGetCheckedKeys = (this as any).$refs[`${this.paneName}OfTree`][0].getCheckedKeys(true)
      if (!listForGetCheckedKeys.length) return this.$message.warning('抱歉，您暂未选择学校哦！')
      const params = {
        school: listForGetCheckedKeys[0],
        year: this.yearForDate
      }
      if (this.subjectChecked) {
        if (this.subjectChecked.length) {
          Object.assign(params, {
            subject: this.subjectChecked[this.subjectChecked.length - 1]
          })
        }
      }
      this.loadingForGeneralLedgerTableContainer = true
      const { data: result } = await (this as any).$http.reportFormLedger(params)
      this.loadingForGeneralLedgerTableContainer = false
      if (result.code !== 200) {
        this.tableDetailForGeneralLedgerTableContainer = {}
        return this.$message.error(result.msg)
      }
      // 需要对数据进行处理：
      let list = (result.data || []).reduce((resultRes: any, current: any): Array<any> => {
        if (current.monthlyGenerateLedgers) {
          current.monthlyGenerateLedgers.forEach(item => {
            resultRes.push(item)
          })
        }
        return resultRes
      }, [])
      // 添加每个月的最后一天：
      list = list.map(item => {
        const timeArr = DateUtil.getEndDayOfDayThatMonth(item.year + '-' + item.month + '-01').split('-')
        item.day = timeArr[timeArr.length - 1]
        return item
      })
      this.tableDetailForGeneralLedgerTableContainer = {
        list,
        year: this.yearForDate
      }
      if (this.subjectChecked) {
        if (this.subjectChecked.length) {
          const subject = findItemForTree(this.treeDataForDisposeNameSubject, 'children', 'code', this.subjectChecked[this.subjectChecked.length - 1])
          Object.assign(this.tableDetailForGeneralLedgerTableContainer, {
            subject: subject && subject['name'] ? subject['name'] : '- -'
          })
        }
      }
    } catch (err) {
      console.log(err)
    }
  }

  // 收支明细表：
  async getReportFormIncomeAndOutputDetailQuery () {
    try {
      const listForGetCheckedKeys = (this as any).$refs[`${this.paneName}OfTree`][0].getCheckedKeys(true)
      if (!listForGetCheckedKeys.length) return this.$message.warning('抱歉，您暂未选择学校哦！')
      const params = {
        batch: this.batch,
        school: listForGetCheckedKeys[0]
      }
      this.loadingForIncomeAndExpensesDetailTableContainer = true
      const { data: result } = await (this as any).$http.reportFormIncomeAndOutputDetailQuery(params)
      this.loadingForIncomeAndExpensesDetailTableContainer = false
      if (result.code !== 200) {
        this.tableDetailForIncomeAndExpensesDetailTableContainer = {}
        return this.$message.error(result.msg)
      }
      // console.log(result, 'result')
      const resultRes = Object.keys(result.data || {}).reduce((resultRes: any, current: string): any => {
        if (['amortisedInstallation', 'foodIncome', 'foodOutput', 'otherIncome'].includes(current)) {
          result.data[current].forEach(v => {
            resultRes[v.subjectStr + 'thisPeriodAmount'] = v.thisPeriodAmount
            resultRes[v.subjectStr + 'thisYearCount'] = v.thisYearCount
            resultRes[v.subjectStr + 'subject'] = v.subject
          })
        }
        return resultRes
      }, {})
      const timeArr = DateUtil.getEndDayOfDayThatMonth(this.monthForDate + '-01').split(' ')[0].split('-')
      this.tableDetailForIncomeAndExpensesDetailTableContainer = {
        ...resultRes,
        ...(result.data || {}),
        timeArr
      }
      // console.log(this.tableDetailForIncomeAndExpensesDetailTableContainer, 'tableDetailForIncomeAndExpensesDetailTableContainer')
    } catch (err) {
      console.log(err)
    }
  }

  // 资产负债表：
  async getReportFormAssetsAndLiabilitiesQuery () {
    try {
      const listForGetCheckedKeys = (this as any).$refs[`${this.paneName}OfTree`][0].getCheckedKeys(true)
      if (!listForGetCheckedKeys.length) return this.$message.warning('抱歉，您暂未选择学校哦！')
      const params = {
        batch: this.batch,
        school: listForGetCheckedKeys[0]
      }
      this.loadingForPropertyLiabilitiesTableContainer = true
      const { data: result } = await (this as any).$http.reportFormAssetsAndLiabilitiesQuery(params)
      this.loadingForPropertyLiabilitiesTableContainer = false
      if (result.code !== 200) {
        this.tableDetailForPropertyLiabilitiesTableContainer = {}
        return this.$message.error(result.msg)
      }
      // test:
      // result.data = {
      //   assets: [
      //     {
      //       endThisPeriod: '100.00',
      //       initThisYear: '400.00',
      //       subjectStr: '现金'
      //     }
      //   ],
      //   income: [],
      //   liabilities: [],
      //   netAssets: [],
      //   output: [],
      //   school: '公安县第一中学',
      //   financePrincipal: '公安县第一中学',
      //   poster: '公安县第一中学'
      // }
      // console.log(result, 'result')
      const resultRes = Object.keys(result.data || {}).reduce((resultRes: any, current: string): any => {
        if (['assets', 'income', 'liabilities', 'netAssets', 'output'].includes(current)) {
          result.data[current].forEach(v => {
            resultRes[v.subjectStr + 'initThisYear'] = v.initThisYear
            resultRes[v.subjectStr + 'endThisPeriod'] = v.endThisPeriod
          })
        }
        return resultRes
      }, {})
      const timeArr = DateUtil.getEndDayOfDayThatMonth(this.monthForDate + '-01').split(' ')[0].split('-')
      this.tableDetailForPropertyLiabilitiesTableContainer = {
        ...resultRes,
        ...(result.data || {}),
        timeArr
      }
      // console.log(this.tableDetailForPropertyLiabilitiesTableContainer, 'tableDetailForPropertyLiabilitiesTableContainer')
    } catch (err) {
      console.log(err)
    }
  }

  // 余额表：
  async getReportFormSubjectBalanceQuery () {
    try {
      const listForGetCheckedKeys = (this as any).$refs[`${this.paneName}OfTree`][0].getCheckedKeys(true)
      if (!listForGetCheckedKeys.length) return this.$message.warning('抱歉，您暂未选择学校哦！')
      const params = {
        batch: this.batch,
        school: listForGetCheckedKeys[0]
      }
      this.loadingForRemainingSumTableContainer = true
      const { data: result } = await (this as any).$http.reportFormSubjectBalanceQuery(params)
      this.loadingForRemainingSumTableContainer = false
      if (result.code !== 200) {
        this.tableDetailForRemainingSumTableContainer = []
        return this.$message.error(result.msg)
      }
      const timeArr = DateUtil.getEndDayOfDayThatMonth(this.monthForDate + '-01').split(' ')[0].split('-')
      this.tableDetailForRemainingSumTableContainer = {
        ...(result.data || {}),
        timeArr
      }
      // console.log(this.tableDetailForRemainingSumTableContainer, 'tableDetailForRemainingSumTableContainer')
    } catch (err) {
      console.log(err)
    }
  }

  // 获取学校基本信息：
  async getSchoolBaseInfo () {
    try {
      const listForGetCheckedKeys = (this as any).$refs[`${this.paneName}OfTree`][0].getCheckedKeys(true)
      if (!listForGetCheckedKeys.length) {
        this.schoolBaseInfo = {}
        return
      }
      const params = {
        orgId: listForGetCheckedKeys[0]
      }
      this.schoolBaseInfoLoading = true
      const { data: result } = await (this as any).$http.portalGetCanteenInfo(params)
      this.schoolBaseInfoLoading = false
      if (result.code !== 200) {
        this.schoolBaseInfo = {}
        return
      }
      this.schoolBaseInfo = (result.data.records.length && result.data.records[0]) || {}
    } catch (err) {
      console.log(err)
    }
  }

  operationForDownload (): void {
    switch (this.paneName) {
      case 'accountingProgress':
        {
          this.loadingForAccountingProgress = true
          const keysList = ['town', 'school', 'January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December']
          const dataRes = ((this as any).tableDataList || []).map(v => {
            return keysList.map(vv => {
              let res = ''
              switch (vv) {
                default:
                  res = v[vv]
              }
              return res
            })
          })
          import('../../plugins/xlsx/exportExcel').then(excel => {
            try {
              excel.export_json_to_excel({
                multiHeader: [
                  ['乡镇', '学校', '账务核算统计（月份）', '账务核算统计（月份）', '账务核算统计（月份）', '账务核算统计（月份）', '账务核算统计（月份）', '账务核算统计（月份）', '账务核算统计（月份）', '账务核算统计（月份）', '账务核算统计（月份）', '账务核算统计（月份）', '账务核算统计（月份）', '账务核算统计（月份）']
                ],
                header: ['', '', '1', '2', '3', '4', '5', '6', '7', '8', '9', '10', '11', '12'],
                autoWidth: true,
                data: dataRes,
                merges: ['A1:A2', 'B1:B2', 'C1:N1'],
                filename: '核算进度表.xlsx'
              })
              this.$message.success('核算进度表，导出成功')
            } catch (err) {
              console.log(err, 'err')
              this.$message.error('抱歉，导出失败')
            }
          })
          setTimeout(() => {
            this.loadingForAccountingProgress = false
          }, 300)
        }
        break
      case 'incomeAndExpenses':
        {
          this.loadingForIncomeAndExpense = true
          const keysList = this.moduleTitleListForIncomeAndExpenses.map(v => v.key).filter(vv => vv !== 'operationInTable')
          const dataRes = ((this as any).tableDataListForIncomeAndExpense || []).map(v => {
            return keysList.map(vv => {
              let res = ''
              switch (vv) {
                default:
                  res = v[vv]
              }
              return res
            })
          })
          import('../../plugins/xlsx/exportExcel').then(excel => {
            let tHeader = this.moduleTitleListForIncomeAndExpenses.map(v => v.title).filter(vv => vv !== '操作')
            try {
              excel.export_json_to_excel({
                multiHeader2: [], // 这里是第一行的表头
                multiHeader: [], // 这里是第二行的表头
                header: tHeader, // 这里应该是算第三行的表头
                data: dataRes,
                merges: [],
                filename: '流水记录表.xlsx'
              })
              this.$message.success('流水记录表，导出成功')
            } catch (err) {
              this.$message.error('抱歉，导出失败')
            }
          })
          setTimeout(() => {
            this.loadingForIncomeAndExpense = false
          }, 300)
        }
        break
      case 'detailAccountTableModule':
        // 废弃原有的图片导出，主要是图片太长了
        // this.downForTable('loadingForDetailAccountTableContainer', 2)
        // 现在采用新的导出：
        {
          this.loadingForDetailAccountTableContainer = true
          const keysList = ['month', 'day', 'proofNum', 'summary', 'debit', 'credit', 'direction', 'balance']
          const dataRes = (this.tableDetailForDetailAccountTableContainer.list || []).map(v => {
            return keysList.map(vv => {
              let res = ''
              switch (vv) {
                default:
                  res = v[vv]
              }
              return res
            })
          })
          import('../../plugins/xlsx/exportExcel').then(excel => {
            try {
              excel.export_json_to_excel({
                multiHeader: [
                  ['科目名称：', this.tableDetailForDetailAccountTableContainer.subject || '- -', this.tableDetailForDetailAccountTableContainer.subject || '- -', this.tableDetailForDetailAccountTableContainer.subject || '- -', this.tableDetailForDetailAccountTableContainer.subject || '- -', this.tableDetailForDetailAccountTableContainer.subject || '- -', this.tableDetailForDetailAccountTableContainer.subject || '- -', this.tableDetailForDetailAccountTableContainer.subject || '- -']
                ],
                multiHeader2: [
                  [this.tableDetailForDetailAccountTableContainer.year + '年', this.tableDetailForDetailAccountTableContainer.year + '年', '凭证号', '摘要', '借方', '贷方', '方向', '余额']
                ],
                header: ['月', '日', '凭证号', '摘要', '借方', '贷方', '方向', '余额'],
                autoWidth: true,
                data: dataRes,
                merges: ['B1:H1', 'A2:B2', 'C2:C3', 'D2:D3', 'E2:E3', 'F2:F3', 'G2:G3', 'H2:H3'],
                filename: this.tableNameText + '（' + this.thisSchoolName + '）' + '.xlsx'
              })
              this.$message.success('公安县中小学食堂明细账，导出成功')
            } catch (err) {
              console.log(err, 'err')
              this.$message.error('抱歉，导出失败')
            }
          })
          setTimeout(() => {
            this.loadingForDetailAccountTableContainer = false
          }, 300)
        }
        break
      case 'generalLedgerTableModule':
        // 废弃原有图片导出：
        // this.downForTable('loadingForGeneralLedgerTableContainer', 3)
        // 现在采用excel导出：
        {
          this.loadingForGeneralLedgerTableContainer = true
          const keysList = ['month', 'day', 'summary', 'debit', 'credit', 'direction', 'balance']
          const dataRes = (this.tableDetailForGeneralLedgerTableContainer.list || []).map(v => {
            return keysList.map(vv => {
              let res = ''
              switch (vv) {
                default:
                  res = v[vv]
              }
              return res
            })
          })
          import('../../plugins/xlsx/exportExcel').then(excel => {
            try {
              excel.export_json_to_excel({
                multiHeader: [
                  ['科目名称：', this.tableDetailForGeneralLedgerTableContainer.subject || '- -', this.tableDetailForGeneralLedgerTableContainer.subject || '- -', this.tableDetailForGeneralLedgerTableContainer.subject || '- -', this.tableDetailForGeneralLedgerTableContainer.subject || '- -', this.tableDetailForGeneralLedgerTableContainer.subject || '- -', this.tableDetailForGeneralLedgerTableContainer.subject || '- -']
                ],
                multiHeader2: [
                  [this.tableDetailForGeneralLedgerTableContainer.year + '年', this.tableDetailForGeneralLedgerTableContainer.year + '年', '摘要', '借方', '贷方', '方向', '余额']
                ],
                header: ['月', '日', '摘要', '借方', '贷方', '方向', '余额'],
                autoWidth: true,
                data: dataRes,
                merges: ['B1:G1', 'A2:B2', 'C2:C3', 'D2:D3', 'E2:E3', 'F2:F3', 'G2:G3'],
                filename: this.tableNameText + '（' + this.thisSchoolName + '）' + '.xlsx'
              })
              this.$message.success('公安县中小学食堂总账，导出成功')
            } catch (err) {
              console.log(err, 'err')
              this.$message.error('抱歉，导出失败')
            }
          })
          setTimeout(() => {
            this.loadingForGeneralLedgerTableContainer = false
          }, 300)
        }
        break
      case 'incomeAndExpensesDetailTableModule':
        this.downForTable('loadingForIncomeAndExpensesDetailTableContainer', 4)
        break
      case 'propertyLiabilitiesTableModule':
        this.downForTable('loadingForPropertyLiabilitiesTableContainer', 5)
        break
      case 'remainingSumTableModule':
        this.downForTable('loadingForRemainingSumTableContainer', 6)
        break
    }
  }

  downForTable (loadingForWho, index): void {
    this.$nextTick(async () => {
      this[loadingForWho] = true
      let _that: any = this
      let ele = document.querySelector(`.idFor${this.tableId}Of${index}`) as any
      let width = ele.offsetWidth
      let height = ele.offsetHeight
      let scale = 6
      const scrollLeft = document.documentElement.scrollLeft || document.body.scrollLeft // 获取滚动轴滚动的长度
      const rect = ele.getBoundingClientRect() // 获取元素相对于视口的
      let canvas = await html2canvas(ele, {
        width,
        height,
        scale,
        useCORS: true, // 【重要】开启跨域配置
        allowTaint: true, // 允许跨域图片
        logging: false,
        x: rect.left, // 绘制的dom元素相对于视口的位置
        y: rect.top,
        scrollX: -scrollLeft, // 滚动的长度
        scrollY: 0
      })
      let imgUrl = canvas.toDataURL('image/png')
      // 下载：
      var eleLink = document.createElement('a')
      eleLink.href = imgUrl // 转换后的图片地址
      eleLink.download = this.tableNameText + '（' + this.thisSchoolName + '）' + '.png'
      document.body.appendChild(eleLink)
      eleLink.click()
      document.body.removeChild(eleLink)
      _that.$message.success('下载成功')
      this[loadingForWho] = false
    })
  }

  cascaderChooseChangeForSubjectTreeData () {
    this.beforeLeave(this.paneName)
  }

  // 获取支出占比、生均量、单价：
  async elPopoverSubjectShow (subjectCode) {
    // try {
    //   if (!subjectCode) {
    //     this.reportFormSubjectAnalyzeDetail = {}
    //     return
    //   }
    //   const listForGetCheckedKeys = (this as any).$refs[`${this.paneName}OfTree`][0].getCheckedKeys(true)
    //   if (!listForGetCheckedKeys.length) {
    //     this.reportFormSubjectAnalyzeDetail = {}
    //     return
    //   }
    //   const params = {
    //     month: this.batch,
    //     school: listForGetCheckedKeys[0],
    //     subject: subjectCode
    //   }
    //   const { data: result } = await (this as any).$http.reportFormSubjectAnalyze(params)
    //   if (result.code !== 200) {
    //     this.reportFormSubjectAnalyzeDetail = {}
    //     return
    //   }
    //   this.reportFormSubjectAnalyzeDetail = result.data || {}
    // } catch (err) {
    //   console.log(err)
    // }
  }
}
